import React, { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { gql, useMutation } from "@apollo/client";
import {
  Alert,
  Button,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { FruitifyContainer } from "../../../shared-components/Containers";

const REQUEST = gql`
  mutation RequestAnnouncementUnsubscribe($email: String!) {
    requestAnnouncementUnsubscribe(email: $email) {
      message
    }
  }
`;
const CONFIRM = gql`
  mutation ConfirmAnnouncementUnsubscribe($token: String!) {
    confirmAnnouncementUnsubscribe(token: $token) {
      message
    }
  }
`;
export default function AnnouncementUnsubscribe() {
  const { token } = useParams();
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [request, requesting] = useMutation(REQUEST);
  const [confirm, confirming] = useMutation(CONFIRM);
  const submit = async (event) => {
    event.preventDefault();
    setError("");
    try {
      const { data } = token
        ? await confirm({ variables: { token } })
        : await request({ variables: { email } });
      setMessage(
        (
          data.confirmAnnouncementUnsubscribe ||
          data.requestAnnouncementUnsubscribe
        ).message,
      );
    } catch (err) {
      setError(err.message);
    }
  };
  return (
    <FruitifyContainer>
      <Paper sx={{ p: { xs: 2, sm: 4 }, maxWidth: 600, mx: "auto", my: 3 }}>
        <Stack spacing={2} component="form" onSubmit={submit}>
          <Typography variant="h5">
            Unsubscribe from Fruitify marketing emails
          </Typography>
          <Typography>
            {token
              ? "Confirm below to stop marketing emails. Your account and transactional emails are unaffected."
              : "Enter the address that received the announcement. We will email a confirmation link so that only you can change your preference. The link expires after 24 hours."}
          </Typography>
          {error && <Alert severity="error">{error}</Alert>}
          {message ? (
            <Alert severity="success">{message}</Alert>
          ) : (
            <>
              {!token && (
                <TextField
                  required
                  fullWidth
                  type="email"
                  label="Email address"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                />
              )}
              <Button
                type="submit"
                variant="contained"
                disabled={requesting.loading || confirming.loading}
              >
                {token ? "Confirm unsubscribe" : "Send confirmation link"}
              </Button>
            </>
          )}
          {token && (
            <Button component={Link} to="/marketing/announcements/unsubscribe">
              Request a new confirmation link
            </Button>
          )}
        </Stack>
      </Paper>
    </FruitifyContainer>
  );
}
